<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';
    import { DialogClose } from 'reka-ui';
    import { Button } from '../Button';
    import { XMarkIcon } from '@heroicons/vue/24/outline';

    const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
    <div
        data-slot="sheet-header"
        :class="cn('flex  gap-2 px-[20x] lg:px-8 py-3 border-b border-border-tertiary', props.class)"
    >
        <div class="flex-1 flex items-center">
            <slot />
        </div>
        <DialogClose as-child>
            <Button
                icon
                variant="secondary"
            >
                <XMarkIcon />
                <span class="sr-only">Close</span>
            </Button>
        </DialogClose>
    </div>
</template>
